export default __webpack_public_path__ + "static/media/kitchen-pack-2.f42ae113.png";